// extracted by mini-css-extract-plugin
export var blue = "_3a-f";
export var brand = "_3a-b";
export var darkGrey = "_3a-e";
export var disabled = "_3a-4";
export var disabledSubtle = "_3a-5";
export var error = "_3a-6";
export var green = "_3a-g";
export var grey = "_3a-d";
export var icon = "_3a-0";
export var inherit = "_3a-a";
export var lightGrey = "_3a-c";
export var orange = "_3a-i";
export var pink = "_3a-k";
export var primary = "_3a-1";
export var purple = "_3a-l";
export var red = "_3a-j";
export var secondary = "_3a-2";
export var success = "_3a-9";
export var tertiary = "_3a-3";
export var warning = "_3a-7";
export var warningSecondary = "_3a-8";
export var white = "_3a-m";
export var yellow = "_3a-h";